import { render, staticRenderFns } from "./peizai.vue?vue&type=template&id=68e25fbc&scoped=true&"
import script from "./peizai.vue?vue&type=script&lang=js&"
export * from "./peizai.vue?vue&type=script&lang=js&"
import style0 from "./peizai.vue?vue&type=style&index=0&id=68e25fbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e25fbc",
  null
  
)

export default component.exports